import { FormattedMessage } from 'dibs-react-intl';

export const frequentlyAskedQuestions = header => (
    <FormattedMessage
        id="buy.frequentlyAskedQuestions"
        defaultMessage="Questions About {header}"
        values={{ header }}
    />
);
